/**
 * Model collection package grid: fetch /apps/specr/api/package-collection,
 * render filtered product cards with sidebar facets.
 */
(function () {
  var root = document.getElementById("package-collection-filters");
  if (!root) return;

  var apiBase = root.getAttribute("data-api") || "/apps/specr/api/package-collection";
  var collectionHandle = root.getAttribute("data-collection-handle") || "";
  var packageCategory = root.getAttribute("data-package-category") || "";
  var specrLabel = root.getAttribute("data-specr-recommended-label") || "Spec R Recommended";
  var showTags = root.getAttribute("data-show-tags") === "1";
  var showSpecrBadge = root.getAttribute("data-show-specr-badge") === "1";
  var cardImageAutoplay = root.getAttribute("data-card-image-autoplay") === "1";
  var cardAutoplaySpeed = parseFloat(root.getAttribute("data-card-autoplay-speed") || "4");
  if (!Number.isFinite(cardAutoplaySpeed)) cardAutoplaySpeed = 4;
  var emptyCategoryMessage = root.getAttribute("data-empty-message") || "No packages in this category for this vehicle yet.";

  var errorEl = document.getElementById("pcf-error");
  var filtersPanel = document.getElementById("pcf-filters");
  var filtersOpenBtn = document.getElementById("pcf-filters-open");
  var filtersCloseBtn = document.getElementById("pcf-filters-close");
  var overlayEl = document.getElementById("pcf-overlay");
  var gridEl = document.getElementById("pcf-grid");
  var loadingEl = document.getElementById("pcf-loading");
  var emptyEl = document.getElementById("pcf-empty");
  var emptyClearBtn = document.getElementById("pcf-empty-clear");
  var resultCountEl = document.getElementById("pcf-result-count");
  var sortEl = document.getElementById("pcf-sort");
  var priceMinEl = document.getElementById("pcf-price-min");
  var priceMaxEl = document.getElementById("pcf-price-max");
  var inStockEl = document.getElementById("pcf-in-stock");
  var featuredEl = document.getElementById("pcf-featured");
  var clearBtn = document.getElementById("pcf-clear-filters");

  var wheelSizeFieldset = document.getElementById("pcf-wheel-size-fieldset");
  var tireBrandFieldset = document.getElementById("pcf-tire-brand-fieldset");
  var studTypeFieldset = document.getElementById("pcf-stud-type-fieldset");
  var tagFieldset = document.getElementById("pcf-tag-fieldset");
  var priceFieldset = document.getElementById("pcf-price-fieldset");
  var inStockWrap = document.getElementById("pcf-in-stock-wrap");
  var featuredWrap = document.getElementById("pcf-featured-wrap");

  var wheelSizeFiltersEl = document.getElementById("pcf-wheel-size-filters");
  var tireBrandFiltersEl = document.getElementById("pcf-tire-brand-filters");
  var studTypeFiltersEl = document.getElementById("pcf-stud-type-filters");
  var tagFiltersEl = document.getElementById("pcf-tag-filters");

  var CONTEXT_PARAM_KEYS = ["package_category"];
  var UI_PARAM_KEYS = [
    "wheelSize",
    "tireBrand",
    "studType",
    "tag",
    "priceMin",
    "priceMax",
    "inStock",
    "featured",
    "sort",
  ];

  var selectedWheelSizes = new Set();
  var selectedTireBrands = new Set();
  var selectedStudTypes = new Set();
  var selectedTags = new Set();

  var allProducts = [];
  var apiData = null;

  function escHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function show(el) {
    if (el) el.hidden = false;
  }
  function hide(el) {
    if (el) el.hidden = true;
  }

  function formatPrice(amount) {
    var n = parseFloat(amount);
    if (!Number.isFinite(n) || n <= 0) return "";
    return "$" + n.toFixed(2);
  }

  function buildApiUrl() {
    var url = new URL(apiBase, window.location.origin);
    url.searchParams.set("collection", collectionHandle);
    if (packageCategory) url.searchParams.set("package_category", packageCategory);
    return url.toString();
  }

  function readUiFiltersFromUrl() {
    var params = new URLSearchParams(window.location.search);
    selectedWheelSizes = new Set(
      (params.get("wheelSize") || "")
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean)
    );
    selectedTireBrands = new Set(
      (params.get("tireBrand") || "")
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean)
    );
    selectedStudTypes = new Set(
      (params.get("studType") || "")
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean)
    );
    selectedTags = new Set(
      (params.get("tag") || "")
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean)
    );
    if (priceMinEl) priceMinEl.value = params.get("priceMin") || "";
    if (priceMaxEl) priceMaxEl.value = params.get("priceMax") || "";
    if (inStockEl) inStockEl.checked = params.get("inStock") === "1";
    if (featuredEl) featuredEl.checked = params.get("featured") === "1";
    if (sortEl) sortEl.value = params.get("sort") || "featured";
  }

  function writeUiFiltersToUrl() {
    var params = new URLSearchParams(window.location.search);
    UI_PARAM_KEYS.forEach(function (key) {
      params.delete(key);
    });
    if (selectedWheelSizes.size) params.set("wheelSize", Array.from(selectedWheelSizes).join(","));
    if (selectedTireBrands.size) params.set("tireBrand", Array.from(selectedTireBrands).join(","));
    if (selectedStudTypes.size) params.set("studType", Array.from(selectedStudTypes).join(","));
    if (selectedTags.size) params.set("tag", Array.from(selectedTags).join(","));
    if (priceMinEl && priceMinEl.value !== "") params.set("priceMin", priceMinEl.value);
    if (priceMaxEl && priceMaxEl.value !== "") params.set("priceMax", priceMaxEl.value);
    if (inStockEl && inStockEl.checked) params.set("inStock", "1");
    if (featuredEl && featuredEl.checked) params.set("featured", "1");
    if (sortEl && sortEl.value && sortEl.value !== "featured") params.set("sort", sortEl.value);
    var qs = params.toString();
    var next = window.location.pathname + (qs ? "?" + qs : "");
    if (next !== window.location.pathname + window.location.search) {
      window.history.replaceState({}, "", next);
    }
  }

  function renderCheckboxList(container, fieldset, items, selectedSet, cssClass, onChange) {
    if (!container || !fieldset) return;
    container.innerHTML = "";
    if (!items.length) {
      fieldset.hidden = true;
      return;
    }
    fieldset.hidden = false;
    items.forEach(function (item) {
      var id = cssClass + "-" + item.value.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
      var label = document.createElement("label");
      label.className = "pcf-filter-check";
      var input = document.createElement("input");
      input.type = "checkbox";
      input.className = cssClass;
      input.id = id;
      input.value = item.value;
      input.checked = selectedSet.has(item.value);
      input.addEventListener("change", function () {
        if (input.checked) selectedSet.add(item.value);
        else selectedSet.delete(item.value);
        onChange();
      });
      var span = document.createElement("span");
      span.textContent = item.label + " (" + item.count + ")";
      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function renderAllFacets(facets) {
    renderCheckboxList(
      wheelSizeFiltersEl,
      wheelSizeFieldset,
      facets.wheelSizes || [],
      selectedWheelSizes,
      "pcf-wheel-size-check",
      function () {
        renderGrid();
        writeUiFiltersToUrl();
      }
    );
    renderCheckboxList(
      tireBrandFiltersEl,
      tireBrandFieldset,
      facets.tireBrands || [],
      selectedTireBrands,
      "pcf-tire-brand-check",
      function () {
        renderGrid();
        writeUiFiltersToUrl();
      }
    );
    renderCheckboxList(
      studTypeFiltersEl,
      studTypeFieldset,
      facets.studTypes || [],
      selectedStudTypes,
      "pcf-stud-type-check",
      function () {
        renderGrid();
        writeUiFiltersToUrl();
      }
    );
    renderCheckboxList(
      tagFiltersEl,
      tagFieldset,
      facets.tags || [],
      selectedTags,
      "pcf-tag-check",
      function () {
        renderGrid();
        writeUiFiltersToUrl();
      }
    );

    if (priceFieldset) {
      priceFieldset.hidden = !(facets.priceMax > 0);
    }
    if (inStockWrap) {
      inStockWrap.hidden = !(facets.booleanCounts && facets.booleanCounts.inStock > 0);
    }
    if (featuredWrap) {
      featuredWrap.hidden = !(facets.booleanCounts && facets.booleanCounts.featured > 0);
    }
  }

  function countMapFromProducts(products, getter) {
    var map = new Map();
    products.forEach(function (p) {
      var val = getter(p);
      if (!val) return;
      map.set(val, (map.get(val) || 0) + 1);
    });
    return map;
  }

  function updateFacetCounts(filteredProducts) {
    if (!apiData || !apiData.facets) return;
    var facets = apiData.facets;

    function rebuild(items, countMap, labelFn) {
      return (items || [])
        .map(function (item) {
          return {
            value: item.value,
            label: labelFn ? labelFn(item) : item.label,
            count: countMap.get(item.value) || 0,
          };
        })
        .filter(function (item) {
          return item.count > 0 || selectedWheelSizes.has(item.value) || selectedTireBrands.has(item.value) || selectedStudTypes.has(item.value) || selectedTags.has(item.value);
        });
    }

    var wheelCounts = countMapFromProducts(filteredProducts, function (p) {
      return p.wheelDiameterInches != null ? String(p.wheelDiameterInches) : "";
    });
    var brandCounts = countMapFromProducts(filteredProducts, function (p) {
      return p.tireBrand || "";
    });
    var studCounts = countMapFromProducts(filteredProducts, function (p) {
      return p.studType || "";
    });

    var tagCounts = new Map();
    filteredProducts.forEach(function (p) {
      (p.tags || []).forEach(function (tag) {
        var t = String(tag).trim();
        if (!t) return;
        if ((facets.tags || []).some(function (f) {
          return f.value.toLowerCase() === t.toLowerCase();
        })) {
          tagCounts.set(t, (tagCounts.get(t) || 0) + 1);
        }
      });
    });

    renderAllFacets({
      wheelSizes: rebuild(facets.wheelSizes, wheelCounts, function (item) {
        return item.label;
      }),
      tireBrands: rebuild(facets.tireBrands, brandCounts),
      studTypes: rebuild(facets.studTypes, studCounts),
      tags: (facets.tags || [])
        .map(function (item) {
          var count = 0;
          tagCounts.forEach(function (c, key) {
            if (key.toLowerCase() === item.value.toLowerCase()) count = c;
          });
          return { value: item.value, label: item.label, count: count };
        })
        .filter(function (item) {
          return item.count > 0 || selectedTags.has(item.value);
        }),
      booleanCounts: facets.booleanCounts,
      priceMin: facets.priceMin,
      priceMax: facets.priceMax,
    });
  }

  function passesFilters(product) {
    if (selectedWheelSizes.size > 0) {
      var ws = product.wheelDiameterInches != null ? String(product.wheelDiameterInches) : "";
      if (!ws || !selectedWheelSizes.has(ws)) return false;
    }
    if (selectedTireBrands.size > 0) {
      var brand = product.tireBrand || "";
      if (!brand || !selectedTireBrands.has(brand)) return false;
    }
    if (selectedStudTypes.size > 0) {
      var stud = product.studType || "";
      if (!stud || !selectedStudTypes.has(stud)) return false;
    }
    if (selectedTags.size > 0) {
      var tags = (product.tags || []).map(function (t) {
        return String(t).trim();
      });
      var tagMatch = false;
      selectedTags.forEach(function (sel) {
        if (
          tags.some(function (t) {
            return t.toLowerCase() === sel.toLowerCase();
          })
        ) {
          tagMatch = true;
        }
      });
      if (!tagMatch) return false;
    }

    var priceMin = priceMinEl && priceMinEl.value !== "" ? parseFloat(priceMinEl.value) : null;
    var priceMax = priceMaxEl && priceMaxEl.value !== "" ? parseFloat(priceMaxEl.value) : null;
    var price = product.priceMin || 0;
    if (priceMin != null && !isNaN(priceMin) && price < priceMin) return false;
    if (priceMax != null && !isNaN(priceMax) && price > priceMax) return false;
    if (inStockEl && inStockEl.checked && !product.available) return false;
    if (featuredEl && featuredEl.checked && !product.featured) return false;
    return true;
  }

  function sortProducts(products) {
    var mode = (sortEl && sortEl.value) || "featured";
    var list = products.slice();
    list.sort(function (a, b) {
      if (mode === "featured") {
        var af = a.featured ? 1 : 0;
        var bf = b.featured ? 1 : 0;
        if (af !== bf) return bf - af;
        return (a.position || 0) - (b.position || 0);
      }
      if (mode === "price_asc") return (a.priceMin || 0) - (b.priceMin || 0);
      if (mode === "price_desc") return (b.priceMin || 0) - (a.priceMin || 0);
      return (a.title || "").localeCompare(b.title || "");
    });
    return list;
  }

  function buildTagsHtml(product) {
    var parts = [];
    if (showSpecrBadge && product.featured) {
      parts.push(
        '<span class="card__product-tag card__product-tag--specr-recommended">' +
          escHtml(specrLabel) +
          "</span>"
      );
    }
    if (showTags && product.tags && product.tags.length) {
      product.tags.slice(0, 5).forEach(function (tag) {
        parts.push('<span class="card__product-tag">' + escHtml(tag) + "</span>");
      });
    }
    if (!parts.length) return "";
    return '<div class="card__product-tags" aria-label="Product tags">' + parts.join("") + "</div>";
  }

  function normalizeImageUrl(url) {
    if (!url) return "";
    url = String(url).trim();
    if (url.indexOf("//") === 0) return "https:" + url;
    return url;
  }

  function productImages(product) {
    if (product.images && product.images.length) {
      return product.images.map(normalizeImageUrl).filter(Boolean);
    }
    if (product.image) return [normalizeImageUrl(product.image)];
    return [];
  }

  function enrichProductImages(products) {
    if (!cardImageAutoplay) return Promise.resolve();

    var need = products.filter(function (p) {
      return productImages(p).length < 2;
    });
    if (!need.length) return Promise.resolve();

    return Promise.all(
      need.map(function (p) {
        return fetch("/products/" + encodeURIComponent(p.handle) + ".js", { credentials: "same-origin" })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            if (!data || !data.images || !data.images.length) return;
            var urls = data.images.map(normalizeImageUrl).filter(Boolean);
            if (urls.length) p.images = urls;
          })
          .catch(function () {});
      })
    );
  }

  function buildMediaHtml(product) {
    var images = productImages(product);
    if (!images.length) {
      return '<div class="media media--transparent media--hover-effect"></div>';
    }

    var sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
    if (cardImageAutoplay && images.length > 1) {
      var imgs = images
        .map(function (url, index) {
          return (
            '<img src="' +
            escHtml(url) +
            '" alt="" loading="lazy" class="card-autoplay-img motion-reduce' +
            (index === 0 ? " is-active" : "") +
            '" sizes="' +
            sizes +
            '">'
          );
        })
        .join("");
      return (
        '<div class="media media--transparent media--card-autoplay" data-card-image-autoplay data-card-autoplay-speed="' +
        escHtml(String(cardAutoplaySpeed)) +
        '" style="--card-autoplay-ar: 1;">' +
        imgs +
        "</div>"
      );
    }

    return (
      '<div class="media media--transparent media--hover-effect">' +
      '<img src="' +
      escHtml(images[0]) +
      '" alt="" loading="lazy" class="motion-reduce" sizes="' +
      sizes +
      '">' +
      "</div>"
    );
  }

  function renderProductCard(product) {
    var li = document.createElement("li");
    li.className = "grid__item";

    var images = productImages(product);
    var wrapperClass = "card-wrapper product-card-wrapper underline-links-hover";
    if (cardImageAutoplay && images.length > 1) {
      wrapperClass += " card-wrapper--autoplay-images";
    }

    var priceHtml = product.priceMin
      ? '<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">Starting from ' +
        escHtml(formatPrice(product.priceMin)) +
        "</span></div></div></div>"
      : "";

    li.innerHTML =
      '<div class="' +
      wrapperClass +
      '">' +
      '<div class="card card--standard card--media card--extend-height">' +
      '<div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 100%;">' +
      '<div class="card__media">' +
      buildMediaHtml(product) +
      "</div>" +
      "</div>" +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h5">' +
      '<a href="' +
      escHtml(product.url) +
      '" class="full-unstyled-link">' +
      escHtml(product.title) +
      "</a></h3>" +
      buildTagsHtml(product) +
      '<div class="card-information">' +
      priceHtml +
      "</div></div></div></div></div>";

    return li;
  }

  function initCardImageAutoplay() {
    if (!cardImageAutoplay || !gridEl) return;

    function tryInit(attempt) {
      if (typeof window.SpecrInitCardImageAutoplay === "function") {
        window.SpecrInitCardImageAutoplay(gridEl);
        return;
      }
      if (attempt < 40) {
        window.setTimeout(function () {
          tryInit(attempt + 1);
        }, 50);
      }
    }

    tryInit(0);
  }

  function destroyCardImageAutoplay() {
    if (!gridEl || typeof window.SpecrDestroyCardImageAutoplay !== "function") return;
    window.SpecrDestroyCardImageAutoplay(gridEl);
  }

  function renderGrid() {
    if (!gridEl) return;
    destroyCardImageAutoplay();
    gridEl.innerHTML = "";

    var filtered = allProducts.filter(passesFilters);
    updateFacetCounts(filtered);
    var sorted = sortProducts(filtered);

    if (resultCountEl) {
      var total = allProducts.length;
      if (filtered.length === total) {
        resultCountEl.textContent = total + (total === 1 ? " package" : " packages");
      } else {
        resultCountEl.textContent = filtered.length + " of " + total + " packages";
      }
    }

    if (!sorted.length) {
      hide(gridEl);
      show(emptyEl);
      if (emptyEl && allProducts.length === 0) {
        var lead = emptyEl.querySelector(".pcf-empty__lead");
        if (lead) lead.textContent = emptyCategoryMessage;
      } else if (emptyEl) {
        var lead2 = emptyEl.querySelector(".pcf-empty__lead");
        if (lead2) lead2.textContent = "No packages match these filters.";
      }
      return;
    }

    show(gridEl);
    hide(emptyEl);
    sorted.forEach(function (p) {
      gridEl.appendChild(renderProductCard(p));
    });
    initCardImageAutoplay();
  }

  function clearAllFilters() {
    selectedWheelSizes.clear();
    selectedTireBrands.clear();
    selectedStudTypes.clear();
    selectedTags.clear();
    if (priceMinEl) priceMinEl.value = "";
    if (priceMaxEl) priceMaxEl.value = "";
    if (inStockEl) inStockEl.checked = false;
    if (featuredEl) featuredEl.checked = false;
    if (sortEl) sortEl.value = "featured";
    if (apiData && apiData.facets) renderAllFacets(apiData.facets);
    renderGrid();
    writeUiFiltersToUrl();
  }

  function openFiltersDrawer() {
    if (filtersPanel) {
      filtersPanel.classList.add("pcf-filters--open");
      filtersPanel.setAttribute("role", "dialog");
      filtersPanel.setAttribute("aria-modal", "true");
    }
    if (overlayEl) {
      show(overlayEl);
      overlayEl.setAttribute("aria-hidden", "false");
    }
    document.body.classList.add("pcf-filters-drawer-open");
  }

  function closeFiltersDrawer() {
    if (filtersPanel) {
      filtersPanel.classList.remove("pcf-filters--open");
      filtersPanel.removeAttribute("role");
      filtersPanel.removeAttribute("aria-modal");
    }
    if (overlayEl) {
      hide(overlayEl);
      overlayEl.setAttribute("aria-hidden", "true");
    }
    document.body.classList.remove("pcf-filters-drawer-open");
  }

  function bindEvents() {
    if (filtersOpenBtn) filtersOpenBtn.addEventListener("click", openFiltersDrawer);
    if (filtersCloseBtn) filtersCloseBtn.addEventListener("click", closeFiltersDrawer);
    if (overlayEl) overlayEl.addEventListener("click", closeFiltersDrawer);
    if (clearBtn) clearBtn.addEventListener("click", clearAllFilters);
    if (emptyClearBtn) emptyClearBtn.addEventListener("click", clearAllFilters);

    [priceMinEl, priceMaxEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener("change", function () {
        renderGrid();
        writeUiFiltersToUrl();
      });
    });
    [inStockEl, featuredEl, sortEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener("change", function () {
        renderGrid();
        writeUiFiltersToUrl();
      });
    });
  }

  function loadResults() {
    show(loadingEl);
    hide(errorEl);
    hide(gridEl);
    hide(emptyEl);

    fetch(buildApiUrl(), { credentials: "same-origin" })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (_ref) {
        var ok = _ref.ok;
        var data = _ref.data;
        hide(loadingEl);
        if (!ok || data.error) {
          if (errorEl) {
            errorEl.textContent = data.error || "Could not load packages.";
            show(errorEl);
          }
          return;
        }
        apiData = data;
        allProducts = data.products || [];
        enrichProductImages(allProducts).then(function () {
          readUiFiltersFromUrl();
          renderAllFacets(data.facets || {});
          renderGrid();
        });
      })
      .catch(function () {
        hide(loadingEl);
        if (errorEl) {
          errorEl.textContent = "Could not load packages. Check your connection and try again.";
          show(errorEl);
        }
      });
  }

  bindEvents();
  loadResults();
})();
